@if(isLoading()){
<div id="useGiftsSection">
  <div id="midSection" class="section">
    <div class="row section-title font-bold">How to redeem your gifts</div>
    <div class="row mobileCol">
      <div class="subsection">
        <div class="row">
          <div class="number font-extrabold">1</div>
          <div class="listText"><span class="font-bold">Download the app</span></div>
        </div>
        <div class="row store-ctas rowImg">
          <a href="/android" target="_blank">
            <img src="old/playstore-btn.png" alt="Get cloudigo on the playstore" class="pl-10" />
          </a>
          <a href="/ios" target="_blank">
            <img src="old/appstore-btn.png" alt="Get cloudigo on the appstore" class="pl-10" />
          </a>
        </div>
        <div class="row">
          <div class="number font-extrabold">2</div>
          <div class="listText">
            <span class="font-bold">Login with your account on the app</span>
          </div>
        </div>
        <div class="row rowImg">
          <img id="loginImg" src="old/tourist/btn_login.png" alt="Login"/>
        </div>
        <div class="row">
          <div class="number font-extrabold">3</div>
          <div class="listText">
            <span class="font-bold">Go to your wallet and redeem in store or online depending on the type of gift</span>
          </div>
        </div>
      </div>
      <div class="subsection imageSection">
        <div id="box">
          <img id="signUpImg" src="old/gift/go_to_wallet.gif" alt="Wallet"/>
        </div>
      </div>
    </div>
  </div>
</div>
} @else {
<div class="svg-loader">
  <object data="old/cloudigo_loader.svg" type="image/svg+xml"></object>
</div>
}